'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$59() {
  this.aVT = null;
  this.aVU = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$59 as $c_Lpresto_GroupRestrictionsView$$anon$59 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$59.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$59;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$59() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$59 as $h_Lpresto_GroupRestrictionsView$$anon$59 };
$h_Lpresto_GroupRestrictionsView$$anon$59.prototype = $p;
$p.P = (function() {
  if ((!this.aVU)) {
    this.aVT = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aVU = true;
  }
  return this.aVT;
});
var $d_Lpresto_GroupRestrictionsView$$anon$59 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$59, "presto.GroupRestrictionsView$$anon$59", ({
  Jd: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$59 as $d_Lpresto_GroupRestrictionsView$$anon$59 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$59.js.map
